import { setActiveTab } from '../../../State/activeTab'

export default (key) => (dispatch) => {

  dispatch(setActiveTab(key))

}
